import { Box, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React, { useCallback } from "react";

import { CmsContentBlock, CmsContentBlockComments } from "../../../../types/CmsPageData";
import { useCmsEditorContext } from "../../../masks/CmsEditorContext";
import { CmsContentEditor } from "../CmsContentEditor";
import { CmsContentTypeProps } from "./CmsContentTypeProps";

export interface CmsContentCommentsProps extends CmsContentTypeProps {
    contentNode: CmsContentBlockComments;
}

export function CmsContentComments({
    contentNode,
    editMode,
    startEditMode,
    stopEditMode,
    showLayoutMenu,
}: CmsContentCommentsProps) {
    const { contentIndex, setContentIndex, setFormHasChangesAction } = useCmsEditorContext();

    const updateContentNode = useCallback(
        (newContent: CmsContentBlock) => {
            setContentIndex({
                ...contentIndex,
                [contentNode.id]: {
                    ...newContent,
                } as CmsContentBlockComments,
            });
            setFormHasChangesAction();
        },
        [contentIndex, setContentIndex, contentNode]
    );

    if (!editMode) {
        return (
            <Box onClick={startEditMode}>
                <Typography variant="body2">Kommentare</Typography>
                <Skeleton variant={"rect"} style={{ width: "500px", height: "150px" }} animation={false} />
            </Box>
        );
    }

    return (
        <CmsContentEditor
            stopEditMode={stopEditMode}
            contentNode={contentNode}
            updateContentNode={updateContentNode}
            showLayoutMenu={showLayoutMenu}
        >
            <Typography variant="body2">Kommentare</Typography>
            <Skeleton variant={"rect"} style={{ width: "500px", height: "150px" }} animation={false} />
        </CmsContentEditor>
    );
}
